import React, { Fragment } from "react";

import {
  BlockDeviceDropdownItem,
  BlockDeviceModalItem,
} from "../../../../../../components/devices/blockDeviceItem";
import { DeviceDropdownMenu } from "../../../../../../components/devices/DeviceDropdownMenu";
import { NotMobile, Mobile } from "../../../../../../hocs/Responsive";
import { DeviceActionsToggle } from "../../../../../../components/devices/DeviceActionsDialog";

export const InfectedDevicesActionsDropdown = ({ device }) => {
  const dropdownItems = [<BlockDeviceDropdownItem device={device} />];
  const modalItems = [<BlockDeviceModalItem device={device} />];

  return (
    <Fragment>
      <Mobile>
        <DeviceActionsToggle deviceName={device.name} menuItems={modalItems} />
      </Mobile>
      <NotMobile>
        <DeviceDropdownMenu menuItems={dropdownItems} />
      </NotMobile>
    </Fragment>
  );
};
